import React, { Component } from 'react';
import API from '../../utils/API';
import Branding from '../branding/branding';
import AccountDetails from '../account/accountDetails';
import SubscriptionAndBilling from './subscriptionAndBilling';
import LoadingWizard from '../../components/spinner/wizard';
import TabsContainer from '../../components/views/TabsContainer';
import Typography from './typography';
import InputField from '../../components/inputs/inputField';
import ColorField from '../../components/inputs/colorField';
import SelectField from '../../components/inputs/selectField';
import PagePreviewFrame from '../pages/components/pagePreviewFrame';
import Integrations from './accountIntegrations';
import SectionFooter from '../../components/views/SectionFooter';
import CustomStyling from '../../sections/event/pages/customStyling';
import Billing from './billing';
import FileChooserPreview from '../../components/inputs/fileChooserPreview';
import FilesUploaderModal from '../../components/files/filesUploaderModal';
import ToggleField from '../../components/inputs/toggleField';
import RichTextEditor from '../pages/components/richTextEditor';

const textTransformOptions = [
	{ label: 'Default', value: 'none' },
	{ label: 'Capitalize', value: 'capitalize' },
	{ label: 'lowercase', value: 'lowercase' },
	{ label: 'UPPERCASE', value: 'uppercase' }
];
const tabMap = {
	details: 0,
	account: 1,
	advanced: 2,
}

const contactBaseFields = [
	{ label: 'First Name', value: 'firstName', fieldName: 'First Name' },
	{ label: 'Last Name', value: 'lastName', fieldName: 'Last Name' },
	{ label: 'Email Address', value: 'emailAddress', fieldName: 'Email Address' },
	{ label: 'Phone Number', value: 'phoneNumber', fieldName: 'Phone Number' },
	{ label: 'Company', value: 'company', fieldName: 'Company' },
	{ label: 'Title', value: 'title', fieldName: 'Title' },
	{ label: 'Dietary Preferences', value: 'dietaryPreference', fieldName: 'Dietary Preferences' },
	{ label: 'Food Allergies', value: 'foodAllergies', fieldName: 'Food Allergies' },
	{ label: 'Emergency Contact Name', value: 'emergencyContactName', fieldName: 'Emergency Contact Name' },
	{ label: 'Emergency Contact Phone', value: 'emergencyContactPhoneNumber', fieldName: 'Emergency Contact Phone' },
	{ label: 'Address', value: 'address', fieldName: 'Address' },
	{ label: 'Address 2', value: 'address2', fieldName: 'Address 2' },
	{ label: 'City', value: 'city', fieldName: 'City' },
	{ label: 'State', value: 'state', fieldName: 'State' },
	{ label: 'Zip', value: 'zip', fieldName: 'Zip' },
	{ label: 'Country', value: 'country', fieldName: 'Country' },
];

const ENV =
	process.env.NODE_ENV === 'production'
		? window.location.href.includes('planner.simple.events') ? `https://admin-api.simple.events/` : `https://beta-api.simple.events/`
		: `http://${window.location.hostname}:5015/`;

class Account extends Component {
	constructor(props) {
		super(props);
		const { orgId } = props
		const urlParams = new URLSearchParams(window.location.search);
		const selectedTab = urlParams.get('tab');
		this.state = {
			accountData: {},
			selectedSection: 0,
			searchSelected: false,
			loading: true,
			adding: false,
			selectedFilter: 0,
			editing: false,
			editingModal: false,
			editedAccountData: {},
			editedOrgStyles: {},
			searchIntegration: '',
			filteredIntegration: 'All',
			editCount: 0,
			selectedSubSection: 0,
			selectedSectionA: selectedTab ? tabMap[selectedTab] : 0,
			renderURL: `Organizations/${this.props.orgId}/accountPages/render/stylePreview/`,
			routeMap: {
				0: `/${orgId}/account/settings`,
				1: `/${orgId}/account/subscription`,
				2: `/${orgId}/account/branding`,
				3: `/${orgId}/account/integrations/all`
			},
			customFields: [],
			selectedDefaultPagesTab: 0,
			selectedContactField: null,
		};
	}

	componentDidMount() {
		let searchParams = new URLSearchParams(window.location.href.substring(window.location.href.indexOf('?')));

		API().get(`Organizations/${this.props.orgId}/account/`).then((res) => {
			if (res.data) {
				const publicPathOptions = res.data.orgPages
					.map((po) => {
						if (po.openToPublic) return { label: po.title, value: po.pathSlug };
						return false;
					})
					.filter((p) => !!p);
				const privatePathOptions = res.data.orgPages.map((po) => {
					return { label: po.title, value: po.pathSlug };
				});
				const customFields = res.data.customFields || [];
				this.setState({
					accountData: JSON.parse(JSON.stringify(res.data)),
					editedAccountData: res.data,
					loading: false,
					selectedSection: searchParams.get('section') ? parseInt(searchParams.get('section')) : 0,
					integrationToken: searchParams.get('code') ? searchParams.get('code') : false,
					editedOrgStyles: JSON.parse(JSON.stringify(res.data.style)),
					publicPathOptions: publicPathOptions,
					privatePathOptions: privatePathOptions,
					subscription: res.data.subscription,
					customFields: customFields
				});
			}
		});

	}

	saveChanges = (cb) => {
		API()
			.patch(`/Organizations/${this.props.orgId}/account`, {
				...this.state.editedAccountData,
				style: this.state.editedOrgStyles
			})
			.then((res) => {
				if (res.data) {
					this.setState({
						editing: false,
						editingModal: false
					});
					cb && cb();
				}
			})
			.catch((e) => {
				//this.setState({ editing: false, editedAccountData: this.state.accountData });
			});
	};

	editAccountData = (data) => {
		console.log(data);

		this.setState({ editedAccountData: data, editing: true });
	};


	updateDefaultCSS = (val) => {
		const { editedAccountData } = this.state;

		editedAccountData.branding.defaultCSS = val;
		this.setState({ editedAccountData: editedAccountData, editCount: this.state.editCount + 1, editingModal: true, editing: true })
	}
	updateEventStyles = (property, value) => {
		const editedOrgStyles = this.state.editedOrgStyles;
		editedOrgStyles[property] = value;
		this.setState({ editedOrgStyles: editedOrgStyles, editCount: this.state.editCount + 1, editing: this.state.brandingEditorOpen ? false : true, editingModal: this.state.brandingEditorOpen ? true : false });
	};

	cancelEdit = () => {
		this.setState({ editing: false, editedAccountData: JSON.parse(JSON.stringify(this.state.accountData)), editedOrgStyles: JSON.parse(JSON.stringify(this.state.accountData.style)) });
	};

	renderPage = () => {
	};

	updateSelectedSubSection = (index) => {
		this.setState({ selectedSubSection: index });
	};

	updateSelectedSection = (index) => {
		this.setState({ selectedSection: index });
	};
	updateSelected = (selected) => {
		this.setState({ selectedSectionA: selected });
	};

	updateSubscription = (sub) => {
		this.setState({ subscription: sub });
	}

	updateSelectedDefaultPagesTab = (index) => {
		this.setState({ selectedDefaultPagesTab: index });
	};

	getContactFieldOptions = () => {
		const customFieldDefs = this.state.editedAccountData.customFields || [];
		const customOptions = [];
		customFieldDefs.forEach((category) => {
			(category.fields || []).forEach((field) => {
				customOptions.push({
					label: `${field.fieldName}`,
					value: `${field._id}`,
					fieldName: field.fieldName
				});
			});
		});
		return [...contactBaseFields, ...customOptions];
	};

	addContactField = () => {
		const { selectedContactField, editedAccountData } = this.state;
		if (!selectedContactField) return;
		const currentFields = editedAccountData.branding.profilePageEditableFields || [];
		if (currentFields.some((f) => f.value === selectedContactField.value)) return;
		this.editAccountData({
			...editedAccountData,
			branding: {
				...editedAccountData.branding,
				profilePageEditableFields: [...currentFields, { label: selectedContactField.label, value: selectedContactField.value }]
			}
		});
		this.setState({ selectedContactField: null });
	};

	removeContactField = (fieldValue) => {
		const { editedAccountData } = this.state;
		const currentFields = editedAccountData.branding.profilePageEditableFields || [];
		this.editAccountData({
			...editedAccountData,
			branding: {
				...editedAccountData.branding,
				profilePageEditableFields: currentFields.filter((f) => f.value !== fieldValue)
			}
		});
	};

	render() {
		const {
			loading,
			selectedSection,
			selectedSectionA,
			editing,
			accountData,
			editedAccountData,
			editedOrgStyles,
			searchIntegration,
			filteredIntegration,
			integrationToken,
			selectedSubSection,
			subscription,
			invoices,
			selectedDefaultPagesTab,
			selectedContactField,
		} = this.state;
		const { orgId } = this.props;
		const organization = accountData;

		//defaultCSS

		let fontOptions = [];
		if (organization.branding) {
			fontOptions = [...organization.branding.fonts].map((f) => {
				return { label: f.name, value: f.name };
			});
		}
		const integrationCategories = ["All", "Integrated", "Unintegrated"];
		editedAccountData.integrations && editedAccountData.integrations.forEach((integration) => {
			if (!integrationCategories.includes(integration.category)) {
				integrationCategories.push(integration.category);
			}
		});
		const tabs = [
			{ title: 'Details' },
			{ title: 'Account Pages' },
			{ title: 'Advanced' },
		]
		return <div className='h-100'>
			{!loading && <div className="flex h-100">
				<div className='p-50' style={{ background: 'var(--input)', width: 312, borderRadius: '15px' }}>
					<h1 className='nowrap mb-20'>Manage Account</h1>
					<h5 className='mb-20'>Settings</h5>
					<button className={`sideNav ${selectedSection === 0 ? 'selected' : ''}`} onClick={() => this.setState({ selectedSection: 0 })}>Overview</button>
					<button className={`sideNav ${selectedSection === 1 ? 'selected' : ''}`} onClick={() => this.setState({ selectedSection: 1 })}>Integrations</button>
					<button className={`sideNav ${selectedSection === 5 ? 'selected' : ''}`} onClick={() => this.setState({ selectedSection: 5 })}>Billing</button>
					<h5 className='mt-30 mb-20'>Branding</h5>
					<button className={`sideNav ${selectedSection === 3 ? 'selected' : ''}`} onClick={() => this.setState({ selectedSection: 3 })}>Basic</button>
					<button className={`sideNav ${selectedSection === 4 ? 'selected' : ''}`} onClick={() => this.setState({ selectedSection: 4 })}>Advanced</button>
					<button className={`sideNav ${selectedSection === 6 ? 'selected' : ''}`} onClick={() => this.setState({ selectedSection: 6, selectedDefaultPagesTab: 0 })}>Default Pages</button>



				</div>
				<div className='flex column p-50 w-100'  >
					<div style={{ height: 'calc(100% - 82px)' }}>
						{selectedSection === 0 ? <div className="sectionBody pt-0">
							<h1 className='mb-20 '>Overview</h1>

							<TabsContainer
								tabs={tabs}
								updateSelected={this.updateSelected}
								selectedIndex={selectedSectionA}
							/>


							<div style={{ overflowX: 'hidden', maxHeight: 'calc(100% - 85px)' }}>
								<AccountDetails orgId={orgId} accountData={editedAccountData} editAccountData={this.editAccountData} selectedIndexA={selectedSectionA} updateSelected={this.updateSelected} customFields={this.state.customFields} /></div>
						</div> : selectedSection === 2 ? <div className="sectionBody pt-0">
							<h1>Subscription</h1>
							<hr />
							<div style={{ overflowX: 'hidden', maxHeight: 'calc(100% - 85px)' }}>
								<SubscriptionAndBilling
									accountData={editedAccountData}
									editAccountData={this.editAccountData}
								/>
							</div>
						</div>
							: selectedSection === 3 ? <div className="sectionBody pt-0 h-100">
								<h1>Basic Branding</h1>
								<hr />
								<div className='blocksContainer flex h-100' style={{ overflowX: 'hidden', maxHeight: 'calc(100% - 56px)' }}>
									<div className='sectionBlock mr-25'>
										<Branding orgId={orgId} accountData={editedAccountData} editAccountData={this.editAccountData} />
										<Typography
											accountData={editedAccountData}
											editAccountData={(editedBranding) => {
												const editedAccountData = this.state.editedAccountData;
												editedAccountData.branding = editedBranding;
												this.editAccountData(editedAccountData);
											}}
										/>
									</div>

									<div className='sectionBlock emailDesignPreview mt-20 mr-5'>
										<div
											className=" eFrame flex-ac preview" style={{ height: 'calc(100% - 2px)' }}
										>

											{!this.state.brandingEditorOpen && <PagePreviewFrame
												setPreviewDimensions={({ width, height }) => {
													this.setState({
														frameWidth: width,
														frameHeight: height
													});
												}}
												ref={(el) => (this.preview = el)}
												editing={this.state.editCount}
												saving={this.state.saving}
												ENV={ENV}
												renderURL={this.state.renderURL}
												pageProperties={{}}
												simulatedUser={{}}
												simulatedSession={{}}
											/>}
										</div>
									</div>

								</div>
							</div>
								: selectedSection === 4 ? <div className='sectionBody pt-0 h-100'>

									<h1 className='mb-10'>Advanced Branding</h1>
									<div className='sectionContainer h-100' style={{ overflowX: 'hidden', maxHeight: 'calc(100% - 56px)' }}>
										<TabsContainer
											tabs={[
												{ title: 'Colors' },
												{ title: 'Text' },
												{ title: 'Spacing' },
												{ title: 'Custom Styling' }
											]}
											updateSelected={this.updateSelectedSubSection}
											selectedIndex={selectedSubSection}
										/>

										<div className="sectionBody h-100">
											<div className="flex h-100">
												<div
													className="sectionBlock"
													style={{ maxHeight: '100%', overflowX: 'hidden', paddingRight: 5 }}
												>
													{selectedSubSection === 2 && <div><h2 className="blockHeader">Content Styles</h2>
														<div style={{ position: 'relative' }}>
															<InputField
																label="Max Content Width"
																value={
																	editedOrgStyles.maxContentWidth
																}
																onChange={(e) => this.updateEventStyles('maxContentWidth', e.target.value)}
															/>
															{editedOrgStyles.maxContentWidth && (
																<i
																	className="las la-times-circle"
																	style={{
																		position: 'absolute',
																		top: '70%',
																		right: '15px',
																		cursor: 'pointer',
																		color: '#6c757d',
																		fontSize: '16px'
																	}}
																	onClick={() => this.updateEventStyles('maxContentWidth', '')}
																	title="Clear field"
																/>
															)}
														</div>

														<h4 >Default Content Padding</h4>
														<div className="flex-ac">
															<InputField
																label="Padding Top "
																classes="mr-5"
																value={
																	editedOrgStyles.contentPaddingTop
																}
																onChange={(e) => this.updateEventStyles('contentPaddingTop', e.target.value)}
															/>
															<InputField
																label="Padding Left "
																classes="mr-5 ml-5"
																value={
																	editedOrgStyles.contentPaddingLeft
																}
																onChange={(e) => this.updateEventStyles('contentPaddingLeft', e.target.value)}
															/>
															<InputField
																label="Padding Bottom "
																classes="mr-5 ml-5"
																value={
																	editedOrgStyles.contentPaddingBottom
																}
																onChange={(e) => this.updateEventStyles('contentPaddingBottom', e.target.value)}
															/>
															<InputField
																label="Padding Right "
																classes="ml-5"
																value={
																	editedOrgStyles.contentPaddingRight
																}
																onChange={(e) => this.updateEventStyles('contentPaddingRight', e.target.value)}
															/>
														</div>
														<h4 >Default Button Padding</h4>
														<div className="flex-ac">
															<InputField
																label="Padding Top "
																classes="mr-5"
																value={
																	editedOrgStyles.buttonPaddingTop
																}
																onChange={(e) => this.updateEventStyles('buttonPaddingTop', e.target.value)}
															/>

															<InputField
																label="Padding Left "
																classes="mr-5 ml-5"
																value={
																	editedOrgStyles.buttonPaddingLeft
																}
																onChange={(e) => this.updateEventStyles('buttonPaddingLeft', e.target.value)}
															/>
															<InputField
																label="Padding Bottom "
																classes="mr-5 ml-5"
																value={
																	editedOrgStyles.buttonPaddingBottom
																}
																onChange={(e) => this.updateEventStyles('buttonPaddingBottom', e.target.value)}
															/>
															<InputField
																label="Padding Right "
																classes="ml-5"
																value={
																	editedOrgStyles.buttonPaddingRight
																}
																onChange={(e) => this.updateEventStyles('buttonPaddingRight', e.target.value)}
															/>
														</div>
														<h4 >Default Border Radius</h4>
														<div className="flex-ac">
															<InputField
																label="Button Radius "
																classes="mr-5"
																value={
																	editedOrgStyles.buttonBorderRadius
																}
																onChange={(e) => this.updateEventStyles('buttonBorderRadius', e.target.value)}
															/>
															<InputField
																label="Input Radius"
																classes="mr-5 ml-5"
																value={
																	editedOrgStyles.inputBorderRadius
																}
																onChange={(e) => this.updateEventStyles('inputBorderRadius', e.target.value)}
															/>
															<InputField
																label="Card Radius"
																classes="ml-5"
																value={
																	editedOrgStyles.cardBorderRadius
																}
																onChange={(e) => this.updateEventStyles('cardBorderRadius', e.target.value)}
															/>
														</div></div>}

													{selectedSubSection === 0 && <div><h2 className="blockHeader">Color Styles</h2>

														<h4 >Default Colors</h4>
														<div className="flex-ac">
															<ColorField
																label="Primary Accent Color"
																classes="mr-5"
																type="color"
																value={
																	editedOrgStyles.primaryColor
																}
																onChange={(e) =>
																	this.updateEventStyles('primaryColor', e.target ? e.target.value : e)}
															/>
															<ColorField
																label="Primary Text Color"
																classes="mr-5 ml-5"
																type="color"
																value={
																	editedOrgStyles.secondaryColor
																}
																onChange={(e) =>
																	this.updateEventStyles('secondaryColor', e.target ? e.target.value : e)}
															/>
														</div>

														<h4 >Navigation Text Color</h4>
														<div className="flex-ac">
															<ColorField
																label="Default"
																classes="mr-5"
																type="color"
																value={
																	editedOrgStyles.navigationTextColor}
																onChange={(e) =>
																	this.updateEventStyles(
																		'navigationTextColor',
																		e.target ? e.target.value : e
																	)}
															/>
															<ColorField
																label="Hover"
																classes="mr-5 ml-5"
																type="color"
																value={
																	editedOrgStyles.navigationHoverColor
																}
																onChange={(e) =>
																	this.updateEventStyles(
																		'navigationHoverColor',
																		e.target ? e.target.value : e
																	)}
															/>
															<ColorField
																label="Visited"
																classes="ml-5"
																type="color"
																value={
																	editedOrgStyles.navigationVisitedColor
																}
																onChange={(e) =>
																	this.updateEventStyles(
																		'navigationVisitedColor',
																		e.target ? e.target.value : e
																	)}
															/>
														</div>
														<h4 >Link Color</h4>
														<div className="flex-ac">
															<ColorField
																label="Default"
																classes="mr-5"
																type="color"
																value={
																	editedOrgStyles.linkTextColor
																}
																onChange={(e) =>
																	this.updateEventStyles('linkTextColor', e.target ? e.target.value : e)}
															/>
															<ColorField
																label="Hover"
																classes="mr-5 ml-5"
																type="color"
																value={
																	editedOrgStyles.linkHoverColor
																}
																onChange={(e) =>
																	this.updateEventStyles('linkHoverColor', e.target ? e.target.value : e)}
															/>
															<ColorField
																label="Visited"
																classes="ml-5"
																type="color"
																value={
																	editedOrgStyles.linkVisitedColor
																}
																onChange={(e) =>
																	this.updateEventStyles('linkVisitedColor', e.target ? e.target.value : e)}
															/>
														</div>
														<h4 >Button Color</h4>
														<div className="flex-ac">
															<ColorField
																label="Primary"
																classes="mr-5"
																type="color"
																value={
																	editedOrgStyles.buttonPrimaryColor
																}
																onChange={(e) =>
																	this.updateEventStyles('buttonPrimaryColor', e.target ? e.target.value : e)}
															/>

															<ColorField
																label="Secondary"
																classes="ml-5"
																type="color"
																value={
																	editedOrgStyles.buttonSecondaryColor
																}
																onChange={(e) =>
																	this.updateEventStyles(
																		'buttonSecondaryColor',
																		e.target ? e.target.value : e
																	)}
															/>
														</div>
														<h4 >Profile Icon Color</h4>
														<div className="flex-ac">
															<ColorField
																label="Background"
																classes="mr-5"
																type="color"
																value={
																	editedOrgStyles.profileIconPrimaryColor
																}
																onChange={(e) =>
																	this.updateEventStyles(
																		'profileIconPrimaryColor',
																		e.target ? e.target.value : e
																	)}
															/>
															<ColorField
																label="Text"
																classes="ml-5"
																type="color"
																value={
																	editedOrgStyles.profileIconSecondaryColor
																}
																onChange={(e) =>
																	this.updateEventStyles(
																		'profileIconSecondaryColor',
																		e.target ? e.target.value : e
																	)}
															/>
														</div>
														<h4 >Scrollbar Color</h4>
														<div className="flex-ac">
															<ColorField
																label="Bar Color"
																classes="mr-5"
																type="color"
																value={
																	editedOrgStyles.scrollbarColor
																}
																onChange={(e) =>
																	this.updateEventStyles('scrollbarColor', e.target ? e.target.value : e)}
															/>

															<ColorField
																label="Background Color"
																classes="ml-5"
																type="color"
																value={
																	editedOrgStyles.scrollbarBackgroundColor
																}
																onChange={(e) =>
																	this.updateEventStyles(
																		'scrollbarBackgroundColor',
																		e.target ? e.target.value : e
																	)}
															/>
														</div></div>}
													{selectedSubSection === 1 && <div>
														<h2 className="blockHeader">Text Styles</h2>
														<h4 >Default Fonts</h4>
														<div className="flex-ac">
															<SelectField
																label="Primary Font Family"
																style={{ marginRight: 5 }}
																options={fontOptions}
																value={fontOptions.find(
																	(fo) =>
																		fo.value ===
																		editedOrgStyles.primaryFont
																)}
																onChange={(e) => this.updateEventStyles('primaryFont', e.value)}
															/>
															<SelectField
																label="Secondary Font Family"
																style={{ marginLeft: 5 }}
																options={fontOptions}
																value={fontOptions.find(
																	(fo) =>
																		fo.value ===
																		editedOrgStyles.secondaryFont
																)}
																onChange={(e) => this.updateEventStyles('secondaryFont', e.value)}
															/>
														</div>
														<h4 >Navigation Bar</h4>
														<div className="flex-ac">
															<InputField
																label="Font Size "
																classes="mr-5"
																value={
																	editedOrgStyles.navigationBarFontSize
																}
																onChange={(e) =>
																	this.updateEventStyles('navigationBarFontSize', e.target.value)}
															/>

															<SelectField
																label="Font Family"
																style={{ marginRight: 5, marginLeft: 5 }}
																options={fontOptions}
																value={fontOptions.find(
																	(fo) =>
																		fo.value ===
																		editedOrgStyles.navigationBarFontFamily
																)}
																onChange={(e) => this.updateEventStyles('navigationBarFontFamily', e.value)}
															/>
															<SelectField
																label="Font Transform"
																style={{ marginLeft: 5 }}
																options={textTransformOptions}
																value={textTransformOptions.find(
																	(fo) =>
																		fo.value ===
																		editedOrgStyles.navigationBarFontTransform
																)}
																onChange={(e) => this.updateEventStyles('navigationBarFontTransform', e.value)}
															/>
														</div>
														<h4 >Heading 1</h4>
														<div className="flex-ac">
															<SelectField
																label="Font Family"
																style={{ marginRight: 5 }}
																options={fontOptions}
																value={fontOptions.find(
																	(fo) =>
																		fo.value ===
																		editedOrgStyles.heading1FontFamily
																)}
																onChange={(e) => this.updateEventStyles('heading1FontFamily', e.value)}
															/>
															<InputField
																label="Font Size "
																classes="mr-5 ml-5"
																value={
																	editedOrgStyles.heading1FontSize}
																onChange={(e) => this.updateEventStyles('heading1FontSize', e.target.value)}
															/>
															<InputField
																label="Line Height"
																classes="mr-5 ml-5"
																value={
																	editedOrgStyles.heading1LineHeight
																}
																onChange={(e) => this.updateEventStyles('heading1LineHeight', e.target.value)}
															/>
															<InputField
																label="Bottom Margin"
																classes="mr-5"
																value={
																	editedOrgStyles.heading1MarginBottom
																}
																onChange={(e) => this.updateEventStyles('heading1MarginBottom', e.target.value)}
															/>
														</div>
														<h4 >Heading 2</h4>
														<div className="flex-ac">
															<SelectField
																label="Font Family"
																style={{ marginRight: 5 }}
																options={fontOptions}
																value={fontOptions.find(
																	(fo) =>
																		fo.value ===
																		editedOrgStyles.heading2FontFamily
																)}
																onChange={(e) => this.updateEventStyles('heading2FontFamily', e.value)}
															/>
															<InputField
																label="Font Size "
																classes="mr-5 ml-5"
																value={
																	editedOrgStyles.heading2FontSize
																}
																onChange={(e) => this.updateEventStyles('heading2FontSize', e.target.value)}
															/>
															<InputField
																label="Line Height"
																classes="mr-5 ml-5"
																value={
																	editedOrgStyles.heading2LineHeight
																}
																onChange={(e) => this.updateEventStyles('heading2LineHeight', e.target.value)}
															/>
															<InputField
																label="Bottom Margin"
																classes="mr-5"
																value={
																	editedOrgStyles.heading2MarginBottom
																}
																onChange={(e) => this.updateEventStyles('heading2MarginBottom', e.target.value)}
															/>
														</div>
														<h4 >Heading 3</h4>
														<div className="flex-ac">
															<SelectField
																label="Font Family"
																style={{ marginRight: 5 }}
																options={fontOptions}
																value={fontOptions.find(
																	(fo) =>
																		fo.value ===
																		editedOrgStyles.heading3FontFamily
																)}
																onChange={(e) => this.updateEventStyles('heading3FontFamily', e.value)}
															/>
															<InputField
																label="Font Size "
																classes="mr-5 ml-5"
																value={
																	editedOrgStyles.heading3FontSize
																}
																onChange={(e) => this.updateEventStyles('heading3FontSize', e.target.value)}
															/>
															<InputField
																label="Line Height"
																classes="mr-5 ml-5"
																value={
																	editedOrgStyles.heading3LineHeight
																}
																onChange={(e) => this.updateEventStyles('heading3LineHeight', e.target.value)}
															/>
															<InputField
																label="Bottom Margin"
																classes="mr-5"
																value={
																	editedOrgStyles.heading3MarginBottom
																}
																onChange={(e) => this.updateEventStyles('heading3MarginBottom', e.target.value)}
															/>
														</div>
														<h4 >Heading 4</h4>
														<div className="flex-ac">
															<SelectField
																label="Font Family"
																style={{ marginRight: 5 }}
																options={fontOptions}
																value={fontOptions.find(
																	(fo) =>
																		fo.value ===
																		editedOrgStyles.heading4FontFamily
																)}
																onChange={(e) => this.updateEventStyles('heading4FontFamily', e.value)}
															/>
															<InputField
																label="Font Size "
																classes="mr-5 ml-5"
																value={
																	editedOrgStyles.heading4FontSize
																}
																onChange={(e) => this.updateEventStyles('heading4FontSize', e.target.value)}
															/>
															<InputField
																label="Line Height"
																classes="mr-5 ml-5"
																value={
																	editedOrgStyles.heading4LineHeight
																}
																onChange={(e) => this.updateEventStyles('heading4LineHeight', e.target.value)}
															/>
															<InputField
																label="Bottom Margin"
																classes="mr-5"
																value={
																	editedOrgStyles.heading4MarginBottom
																}
																onChange={(e) => this.updateEventStyles('heading4MarginBottom', e.target.value)}
															/>
														</div>
														<h4 >Heading 5</h4>
														<div className="flex-ac">
															<SelectField
																label="Font Family"
																style={{ marginRight: 5 }}
																options={fontOptions}
																value={fontOptions.find(
																	(fo) =>
																		fo.value ===
																		editedOrgStyles.heading5FontFamily
																)}
																onChange={(e) => this.updateEventStyles('heading5FontFamily', e.value)}
															/>
															<InputField
																label="Font Size "
																classes="mr-5 ml-5"
																value={
																	editedOrgStyles.heading5FontSize
																}
																onChange={(e) => this.updateEventStyles('heading5FontSize', e.target.value)}
															/>
															<InputField
																label="Line Height"
																classes="mr-5 ml-5"
																value={
																	editedOrgStyles.heading5LineHeight
																}
																onChange={(e) => this.updateEventStyles('heading5LineHeight', e.target.value)}
															/>
															<InputField
																label="Bottom Margin"
																classes="mr-5"
																value={
																	editedOrgStyles.heading5MarginBottom
																}
																onChange={(e) => this.updateEventStyles('heading5MarginBottom', e.target.value)}
															/>
														</div>
														<h4 >Body</h4>
														<div className="flex-ac">
															<SelectField
																label="Font Family"
																style={{ marginRight: 5 }}
																options={fontOptions}
																value={fontOptions.find(
																	(fo) =>
																		fo.value ===
																		editedOrgStyles.bodyFontFamily
																)}
																onChange={(e) => this.updateEventStyles('bodyFontFamily', e.value)}
															/>
															<InputField
																label="Font Size "
																classes="mr-5 ml-5"
																value={
																	editedOrgStyles.bodyFontSize
																}
																onChange={(e) => this.updateEventStyles('bodyFontSize', e.target.value)}
															/>

															<InputField
																label="Line Height"
																classes="mr-5 ml-5"
																value={
																	editedOrgStyles.bodyLineHeight
																}
																onChange={(e) => this.updateEventStyles('bodyLineHeight', e.target.value)}
															/>
															<InputField
																label="Bottom Margin"
																classes="mr-5 ml-5"
																value={
																	editedOrgStyles.paragraphMarginBottom
																}
																onChange={(e) =>
																	this.updateEventStyles('paragraphMarginBottom', e.target.value)}
															/>
															<SelectField
																label="Bold Font Family"
																style={{ marginRight: 5 }}
																options={fontOptions}
																value={fontOptions.find(
																	(fo) =>
																		fo.value ===
																		editedOrgStyles.bodyBoldFontFamily
																)}
																onChange={(e) => this.updateEventStyles('bodyBoldFontFamily', e.value)}
															/>
														</div>
														<h4 >Input Label</h4>
														<div className="flex-ac">
															<SelectField
																label="Font Family"
																style={{ marginRight: 5 }}
																options={fontOptions}
																value={fontOptions.find(
																	(fo) =>
																		fo.value ===
																		editedOrgStyles.inputLabelFontFamily
																)}
																onChange={(e) => this.updateEventStyles('inputLabelFontFamily', e.value)}
															/>
															<InputField
																label="Font Size "
																classes="mr-5 ml-5"
																value={
																	editedOrgStyles.inputLabelFontSize

																}
																onChange={(e) => this.updateEventStyles('inputLabelFontSize', e.target.value)}
															/>
															<SelectField
																label="Font Transform"
																style={{ marginLeft: 5 }}
																options={textTransformOptions}
																value={textTransformOptions.find(
																	(fo) =>
																		fo.value ===
																		editedOrgStyles.inputLabelFontTransform
																)}
																onChange={(e) => this.updateEventStyles('inputLabelFontTransform', e.value)}
															/>
														</div>
														<h4 >Input Text</h4>
														<div className="flex-ac">
															<SelectField
																label="Font Family"
																style={{ marginRight: 5 }}
																options={fontOptions}
																value={fontOptions.find(
																	(fo) =>
																		fo.value ===
																		editedOrgStyles.inputTextFontFamily
																)}
																onChange={(e) => this.updateEventStyles('inputTextFontFamily', e.value)}
															/>
															<InputField
																label="Font Size "
																classes="mr-5"
																value={
																	editedOrgStyles.inputTextFontSize
																}
																onChange={(e) => this.updateEventStyles('inputTextFontSize', e.target.value)}
															/>
														</div>
														<h4 >Button Text</h4>
														<div className="flex-ac">
															<SelectField
																label="Font Family"
																style={{ marginRight: 5 }}
																options={fontOptions}
																value={fontOptions.find(
																	(fo) =>
																		fo.value ===
																		editedOrgStyles.buttonTextFontFamily
																)}
																onChange={(e) => this.updateEventStyles('buttonTextFontFamily', e.value)}
															/>
															<InputField
																label="Font Size "
																classes="mr-5 ml-5"
																value={
																	editedOrgStyles.buttonTextFontSize
																}
																onChange={(e) => this.updateEventStyles('buttonTextFontSize', e.target.value)}
															/>
															<SelectField
																label="Font Transform"
																style={{ marginLeft: 5 }}
																options={textTransformOptions}
																value={textTransformOptions.find(
																	(fo) =>
																		fo.value ===
																		editedOrgStyles.buttonTextFontTransform
																)}
																onChange={(e) => this.updateEventStyles('buttonTextFontTransform', e.value)}
															/>
														</div>
														<h4>Footer</h4>
														<div className="flex-ac">
															<SelectField
																label="Font Family"
																style={{ marginRight: 5 }}
																options={fontOptions}
																value={fontOptions.find(
																	(fo) =>
																		fo.value ===
																		editedOrgStyles.footerFontFamily
																)}
																onChange={(e) => this.updateEventStyles('footerFontFamily', e.value)}
															/>
															<InputField
																label="Font Size"
																classes="mr-5 ml-5"
																value={
																	editedOrgStyles.footerFontSize
																}
																onChange={(e) => this.updateEventStyles('footerFontSize', e.target.value)}
															/>
															<InputField
																label="Line Height"
																classes="mr-5 ml-5"
																value={
																	editedOrgStyles.footerLineHeight
																}
																onChange={(e) => this.updateEventStyles('footerLineHeight', e.target.value)}
															/>
															<SelectField
																label="Font Transform"
																style={{ marginLeft: 5 }}
																options={textTransformOptions}
																value={textTransformOptions.find(
																	(fo) =>
																		fo.value ===
																		editedOrgStyles.footerFontTransform
																)}
																onChange={(e) => this.updateEventStyles('footerFontTransform', e.value)}
															/>
														</div></div>}
													{selectedSubSection === 3 && <div>
														<h2 className="blockHeader">Custom CSS</h2><p className='mb-20'>The css here will be applied to all the pages within the event.</p>
														<CustomStyling
															eventCustomCSS={editedAccountData.branding.defaultCSS}
															updateStyling={(e) => {
																this.updateDefaultCSS(e)

															}}
															readOnly={false}
														/></div>}
												</div>
												<div className='sectionBlock emailDesignPreview mt-20 mr-5'>
													<div
														className=" eFrame flex-ac preview" style={{ height: 'calc(100% - 2px)' }}
													>
														<PagePreviewFrame
															setPreviewDimensions={({ width, height }) => {
																this.setState({
																	frameWidth: width,
																	frameHeight: height
																});
															}}
															ref={(el) => (this.preview = el)}
															editing={this.state.editCount}
															saving={this.state.saving}
															ENV={ENV}
															renderURL={this.state.renderURL}
															pageProperties={{}}
															simulatedUser={{}}
															simulatedSession={{}}
														/>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div> : selectedSection === 1 ? <div className="sectionBody pt-0 h-100 ">
									<h1>Integrations</h1>
									<hr />
									<div style={{ overflowX: 'hidden', maxHeight: 'calc(100% - 56px)' }}>
										<Integrations
											orgId={this.props.orgId}
											integrations={editedAccountData.integrations}
											searchIntegration={searchIntegration}
											searchIntegrations={(e) => {
												this.setState({ searchIntegration: e.target.value });
											}}
											clearSearch={() => this.setState({ searchIntegration: '' })}
											filterIntegrations={(category) => this.setState({ filteredIntegration: category })}
											integrationCategories={integrationCategories}
											filteredIntegration={filteredIntegration}
											integrationToken={integrationToken}

											toggleEnabled={(integrationIndex, value) => {
												let integrations = editedAccountData.integrations;
												integrations[integrationIndex].enabled = value;
												this.setState({ editedAccountData: { ...editedAccountData, integrations }, editing: true });

											}}
											toggleIntegration={(integrationIndex, value, authenticated, requiredFieldsValues, fieldValues, customFields, isEdit) => {

												let integrations = editedAccountData.integrations;
												if (integrations[integrationIndex]
													&& integrations[integrationIndex].links
													&& integrations[integrationIndex].links.authorize
													&& value
													&& !authenticated) {
													if (requiredFieldsValues || fieldValues) {
														if (requiredFieldsValues) {
															integrations[integrationIndex].requiredFields = integrations[integrationIndex].requiredFields.map(rf => {
																return {
																	...rf,
																	value: requiredFieldsValues[rf.id]
																}
															})
														}
														if (fieldValues) {
															integrations[integrationIndex].fields = integrations[integrationIndex].fields.map(rf => {
																return {
																	...rf,
																	value: fieldValues[rf.id]
																}
															})
														}
														if (customFields) {
															integrations[integrationIndex].customFields = customFields;
														}
														this.saveChanges(() => {
															window.open(integrations[integrationIndex].links.authorize, '_self');
														});
													} else {
														window.open(integrations[integrationIndex].links.authorize, '_self');
													}
													return;
												} else if (authenticated) {
													window.location.href = 'all';
													return
												}
												integrations[integrationIndex].enabled = value;
												this.setState({ editedAccountData: { ...editedAccountData, integrations }, editing: true });
											}} /></div>
								</div>
									: selectedSection === 5 ? <div className="sectionBody pt-0">

										<h1 className='mb-20'>Billing</h1>
										<Billing orgId={orgId} invoices={invoices} subscription={subscription} accountData={editedAccountData} editAccountData={this.editAccountData} updateSubscription={this.updateSubscription} />

									</div> : selectedSection === 6 ? <div className="sectionBody pt-0 h-100">
										<h1 className='mb-20'>Account Page</h1>
										<TabsContainer
											tabs={[
												{ title: 'Login Page' },
												{ title: 'Profile Page' },
											]}
											updateSelected={this.updateSelectedDefaultPagesTab}
											selectedIndex={selectedDefaultPagesTab}
										/>
										<div style={{ overflowX: 'hidden', maxHeight: 'calc(100% - 85px)' }}>
											<div className="sectionContainer mt-20">
												<div className="sectionBody">
													<div className="sectionBlock" style={{ maxHeight: '100%', overflowX: 'hidden', paddingRight: 5 }}>
														{selectedDefaultPagesTab === 0 && <div>
															<h2 className="mb-20 semibold">Login</h2>
															<ToggleField
																label={'Enable SSO'}
																checked={editedAccountData.ssoEnabled}
																icons={false}
																onChange={() => {
																	this.editAccountData({
																		...editedAccountData,
																		ssoEnabled: !editedAccountData.ssoEnabled
																	});
																}}
															/>
															{editedAccountData.ssoEnabled && (
																<>
																	<InputField
																		label={'SSO URL'}
																		value={editedAccountData.ssoUrl}
																		onChange={(e) => {
																			this.editAccountData({
																				...editedAccountData,
																				ssoUrl: e.target.value
																			});
																		}}
																	/>
																	<InputField
																		label={'SSO Button Label'}
																		value={(editedAccountData.branding && editedAccountData.branding.ssoButtonLabel) || ''}
																		onChange={(e) => {
																			this.editAccountData({
																				...editedAccountData,
																				branding: {
																					...editedAccountData.branding,
																					ssoButtonLabel: e.target.value
																				}
																			});
																		}}
																	/>
																</>
															)}
															<RichTextEditor
																id="loginTitle"
																label="Login Page Title"
																value={(editedAccountData.branding && editedAccountData.branding.loginTitle) || ''}
																onChange={(val) => {
																	this.editAccountData({
																		...editedAccountData,
																		branding: {
																			...editedAccountData.branding,
																			loginTitle: val
																		}
																	});
																}}
															/>


															<RichTextEditor
																id="loginCardTitle"
																label="Login Card Title"
																value={(editedAccountData.branding && editedAccountData.branding.loginCardTitle) || ''}
																onChange={(val) => {
																	this.editAccountData({
																		...editedAccountData,
																		branding: {
																			...editedAccountData.branding,
																			loginCardTitle: val
																		}
																	});
																}}
															/>
															<RichTextEditor
																id="loginCardSubtitle"
																label="Login Card Subtitle"
																value={(editedAccountData.branding && editedAccountData.branding.loginCardSubtitle) || ''}
																onChange={(val) => {
																	this.editAccountData({
																		...editedAccountData,
																		branding: {
																			...editedAccountData.branding,
																			loginCardSubtitle: val
																		}
																	});
																}}
															/>
															<RichTextEditor
																id="supportText"
																label="Support Text"
																value={(editedAccountData.branding && editedAccountData.branding.supportText) || ''}
																onChange={(val) => {
																	this.editAccountData({
																		...editedAccountData,
																		branding: {
																			...editedAccountData.branding,
																			supportText: val
																		}
																	});
																}}
															/>
															<FileChooserPreview
																label="Login Page Background"
																value={(editedAccountData.branding && editedAccountData.branding.background) || ''}
																onClick={() => {
																	this.editAccountData({
																		...editedAccountData,
																		branding: {
																			...editedAccountData.branding,
																			background: 'choosing__' + ((editedAccountData.branding && editedAccountData.branding.background) || '')
																		}
																	});
																}}
																clearFile={() => {
																	this.editAccountData({
																		...editedAccountData,
																		branding: {
																			...editedAccountData.branding,
																			background: ''
																		}
																	});
																}}
															/>
															{editedAccountData.branding && (editedAccountData.branding.background || '').includes('choosing__') && (
																<FilesUploaderModal
																	isOpen={(editedAccountData.branding.background || '').includes('choosing__')}
																	toggle={() => {
																		this.editAccountData({
																			...editedAccountData,
																			branding: {
																				...editedAccountData.branding,
																				background: (editedAccountData.branding.background || '').replace('choosing__', '')
																			}
																		});
																	}}
																	links={{
																		getAssets: `Organizations/${orgId}/assets`,
																		addAssets: `Organizations/${orgId}/assets`,
																	}}
																	orgId={orgId}
																	addFiles={(fileURL) => {
																		this.editAccountData({
																			...editedAccountData,
																			branding: {
																				...editedAccountData.branding,
																				background: fileURL
																			}
																		});
																	}}
																/>
															)}
														</div>}
														{selectedDefaultPagesTab === 1 && <div>
															<h2 className="mb-20 semibold">Profile Page Defaults</h2>
															<RichTextEditor
																id="profilePageTitle"
																label="Set Page Title"
																value={(editedAccountData.branding && editedAccountData.branding.profilePageTitle) || ''}
																onChange={(val) => {
																	this.editAccountData({
																		...editedAccountData,
																		branding: {
																			...editedAccountData.branding,
																			profilePageTitle: val
																		}
																	});
																}}
															/>
															<FileChooserPreview
																label="Set Background"
																value={(editedAccountData.branding && editedAccountData.branding.profilePageBackground) || ''}
																onClick={() => {
																	this.editAccountData({
																		...editedAccountData,
																		branding: {
																			...editedAccountData.branding,
																			profilePageBackground: 'choosing__' + ((editedAccountData.branding && editedAccountData.branding.profilePageBackground) || '')
																		}
																	});
																}}
																clearFile={() => {
																	this.editAccountData({
																		...editedAccountData,
																		branding: {
																			...editedAccountData.branding,
																			profilePageBackground: ''
																		}
																	});
																}}
															/>
															{editedAccountData.branding && ((editedAccountData.branding.profilePageBackground || '').includes('choosing__')) && (
																<FilesUploaderModal
																	isOpen={(editedAccountData.branding.profilePageBackground || '').includes('choosing__')}
																	toggle={() => {
																		this.editAccountData({
																			...editedAccountData,
																			branding: {
																				...editedAccountData.branding,
																				profilePageBackground: (editedAccountData.branding.profilePageBackground || '').replace('choosing__', '')
																			}
																		});
																	}}
																	links={{
																		getAssets: `Organizations/${orgId}/assets`,
																		addAssets: `Organizations/${orgId}/assets`,
																	}}
																	orgId={orgId}
																	addFiles={(fileURL) => {
																		this.editAccountData({
																			...editedAccountData,
																			branding: {
																				...editedAccountData.branding,
																				profilePageBackground: fileURL
																			}
																		});
																	}}
																/>
															)}
															<ToggleField
																label={'Enable Editable Profile Image'}
																checked={editedAccountData.branding && editedAccountData.branding.profilePageEnableEditableProfileImage !== false}
																icons={false}
																onChange={() => {
																	const current = editedAccountData.branding && editedAccountData.branding.profilePageEnableEditableProfileImage !== false;
																	this.editAccountData({
																		...editedAccountData,
																		branding: {
																			...editedAccountData.branding,
																			profilePageEnableEditableProfileImage: !current
																		}
																	});
																}}
															/>
															<h2 className="mb-20 mt-20 semibold">Editable Contact Fields</h2>
															<div className="flex-ac mb-10">
																<div style={{ flex: 1, marginRight: 10 }}>
																	<SelectField
																		label="Select Contact Field"
																		value={selectedContactField}
																		options={this.getContactFieldOptions()}
																		onChange={(option) => {
																			this.setState({ selectedContactField: option });
																		}}
																	/>
																</div>
																<button
																	className="neu mt-10"
																	onClick={this.addContactField}
																	disabled={!selectedContactField}
																>
																	Add Contact Field
																</button>
															</div>
															{editedAccountData.branding && (editedAccountData.branding.profilePageEditableFields || []).length > 0 && (
																<div className="mt-10">
																	{(editedAccountData.branding.profilePageEditableFields || []).map((field) => (
																		<div
																			key={field.value}
																			className="flex-ac mb-5"
																			style={{
																				background: 'var(--input)',
																				borderRadius: 5,
																				padding: '6px 12px',
																			}}
																		>
																			<span style={{ flex: 1 }}>{field.label}</span>
																			<i
																				className="las la-times c-pointer"
																				onClick={() => this.removeContactField(field.value)}
																			/>
																		</div>
																	))}
																</div>
															)}
														</div>}
													</div>
												</div>
											</div>
										</div>
									</div> : null}
					</div>
					<SectionFooter
						editing={editing}
						cancelEdit={this.cancelEdit}
						saveEdit={this.saveChanges}
						updatedAt={accountData.updatedAt}
						style={{ marginBottom: 0, marginTop: 50 }}
					/>
				</div>
			</div >}

			<LoadingWizard text="LOADING ACCOUNT INFORMATION" loading={loading} />
		</div >
	}
}

export default Account;
